import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { MouseEvent, MouseEventHandler, ReactNode, useEffect, useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { v4 as uuidv4 } from "uuid";
export interface MenuPropsType extends GeneralPropsType {
  forHTML?: string;
  open?: boolean;
  children: ReactNode[];
  toggleMenu?: (data?: any) => any;
  openFromLeft?: boolean;
  transparentBackground?: boolean;
  delayClose?: number;
  overrideDirection?: "top" | "bottom";
}
export const useMenu = (): [boolean, () => void] => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  return [isOpen, toggleOpen];
};
function Menu({
  children,
  open,
  toggleMenu,
  className,
  openFromLeft,
  transparentBackground,
  delayClose,
  overrideDirection
}: MenuPropsType) {
  const id = useRef(uuidv4());
  const [Trigger, Board] = children;
  const boardRef = useRef<any>();
  const triggerRef = useRef<any>();
  const boardHeight = useRef(0);
  const handleSwitch = (e: MouseEvent) => {
    if (delayClose && open) {
      setTimeout(() => {
        toggleMenu?.(e);
      }, delayClose);
    } else {
      toggleMenu?.(e);
    }
  };
  useEffect(() => {
    boardHeight.current = boardHeight.current || boardRef.current?.clientHeight;
    const body = document.querySelector("body");
    if (!open) {
      const overlay = document.querySelector(`.c${id.current}`);
      overlay?.remove();
      return;
    }
    const trigger = triggerRef.current as HTMLElement;
    const triggerInfo = trigger?.getBoundingClientRect();
    const boardInfo = (boardRef.current as HTMLElement)?.getBoundingClientRect();
    console.log("🚀 ~ useEffect ~ triggerInfo:", triggerInfo, boardHeight.current);
    const overplay = document.createElement("div");
    overplay.classList.add("c" + id.current);
    overplay.style.position = "fixed";
    overplay.style.inset = "0";
    if (!transparentBackground) {
      overplay.style.backgroundColor = "#00000000";
      overplay.style.backdropFilter = "blur(0px)";
    }
    overplay.style.transition = "400ms";
    overplay.style.zIndex = "9999";
    boardRef.current.style.transform = "scale(0)";
    const tm = setTimeout(() => {
      boardRef.current.style.transform = "scale(1)";
      clearTimeout(tm);
    }, 1);
    if (overrideDirection == "bottom" || triggerInfo.bottom + 12 + boardHeight.current > window.innerHeight) {
      boardRef.current.style.bottom = window.innerHeight - triggerInfo.bottom + triggerInfo.height + 12 + "px";
      boardRef.current.style.top = "unset";
      boardRef.current.style.transformOrigin = openFromLeft ? `${overrideDirection ?? "bottom"} left` : `${overrideDirection ?? "bottom"} right`;
    } else {
      boardRef.current.style.transformOrigin = openFromLeft ? `${overrideDirection ?? "top"} left` : `${overrideDirection ?? "top"} right`;
      boardRef.current.style.top = triggerInfo.bottom + 12 + "px";
    }
    if (openFromLeft) {
      // boardRef.current.style.left = window.innerWidth - triggerInfo.left + "px";
      boardRef.current.style.left = triggerInfo.left + "px";
      boardRef.current.style.right = "unset";
    } else {
      boardRef.current.style.right = window.innerWidth - triggerInfo.right + "px";
      // boardRef.current.style.right = window.innerWidth - triggerInfo.right + "px";
      // boardRef.current.style.left = "unset";
    }
    overplay.appendChild(boardRef.current);
    overplay.addEventListener("click", handleSwitch as any);
    body?.appendChild(overplay);
    if (transparentBackground) {
      return;
    }
    const tm2 = setTimeout(() => {
      overplay.style.backgroundColor = "rgba(0, 0, 0, 0.49)";
      overplay.style.backdropFilter = "blur(4px)";
      (overplay.style as any)["-webkit-backdrop-filter"] = "blur(4px)";
      clearTimeout(tm2);
    }, 1);
  }, [open]);
  return <div className={clsx("relative", styles.container, className, styles.backdrop, {
    [styles.open]: open
  })} data-sentry-component="Menu" data-sentry-source-file="index.tsx">
            <div onClick={handleSwitch} ref={triggerRef}>
                {Trigger}
            </div>
            <div ref={boardRef} className={clsx("absolute duration-300 top-full scale-0", {
      "origin-top-left left-0": openFromLeft,
      "origin-top-right right-0": !openFromLeft
    })}>
                {Board}
            </div>
        </div>;
}
export default Menu;